/* @flow */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import type { $StoreState } from '../../types/StoreState';
import AppFieldKeys from 'CoreConstants/FieldKeysSPA';
import FilterType from 'CoreConstants/FilterType';
import Globals from 'CoreConstants/Globals';
import { DISTANCE_UNIT_KM, DefaultDistanceOptions } from 'CoreConstants/DistanceUnits';
import { TemplateMarketPropertyKeys } from 'CoreTemplates/TemplateMarketProperties';
import { getConfigurationMarketProperty } from 'CoreUtils/WidgetUtils';
import { getConfigurationTranslationValue } from 'CoreUtils/WidgetUtils';
import { modifyFilterCriteria } from 'CoreStore/filters';
import WBDropdown from '../../../../dealer-locator-core/src/components/WBDropdown/WBDropdown';

type $MappedProps = {
  dropdownLabel: string,
  distanceUnitLabelKM: string,
  distanceUnitLabelMI: string,
  marketDistanceUnit: string,
  marketSearchRadius: ?string,
  marketDistanceOptions: Array<string>,
  appliedFilteringValues: Array<string>,
  searchCriteria: string,
  coordinates: ?{
    latitude: number,
    longitude: number
  },
  modifyFilterCriteria: Function
};

type $CompomentProps = {
  onFilterSearchRadiusChange: Function,
  selectedValue: string
};

type $Props = $MappedProps & $CompomentProps;

class DealersFilteringDistance extends Component<$Props> {

  handleFilterCheck = (value: string) => {
    this.props.modifyFilterCriteria(FilterType.FILTER_SEARCH_RADIUS, [value]);
    this.props.onFilterSearchRadiusChange([value]);
  };

  render() {

    const { marketDistanceUnit, distanceUnitLabelKM, distanceUnitLabelMI,
      marketDistanceOptions, marketSearchRadius, appliedFilteringValues } = this.props;
    const distanceUnitTranslation = marketDistanceUnit === DISTANCE_UNIT_KM ?
      distanceUnitLabelKM : distanceUnitLabelMI;

    const markerDistanceValues = marketDistanceOptions.every(marketOption => marketOption !== null) ?
      marketDistanceOptions :
      [
        DefaultDistanceOptions.RADIUS_10,
        DefaultDistanceOptions.RADIUS_25,
        DefaultDistanceOptions.RADIUS_50
      ];

      const defaultValueExistsInAvailableOptions = marketSearchRadius ?
      markerDistanceValues.findIndex(v => v === String(marketSearchRadius)) !== -1 : true;

    // this.props.appliedFilteringValues can be a string or an Array with the first value being the selectedValue
    let selectedValue = ""

    if (Array.isArray(appliedFilteringValues)) {
      if (appliedFilteringValues.length > 0) selectedValue = appliedFilteringValues[0]
    } else {
      if (appliedFilteringValues) {
        selectedValue = String(appliedFilteringValues)
      }
    }

    return this.props.coordinates && distanceUnitTranslation ? (
      <div className="dsw-search-results-filter__dropdown">
       <WBDropdown
        placeholder={
          defaultValueExistsInAvailableOptions
            ? ""
            : `${marketSearchRadius
              ? marketSearchRadius
              : markerDistanceValues[1]
            } ${distanceUnitTranslation}`
        }
        labels={markerDistanceValues.map(
          distanceValue => `${distanceValue} ${distanceUnitTranslation}`
        )}
        values={markerDistanceValues}
        selectedValue={selectedValue ? selectedValue : marketSearchRadius ? "" : markerDistanceValues[1]}
        onChange={this.handleFilterCheck}
        modifierClass={'dsw-search-results-filter__dropdown__wb'}
      />
      </div>
    ) : null;
  }
}

const mapStateToProps = (state: $StoreState) => ({
  dropdownLabel: getConfigurationTranslationValue(
    state.dsw.translations || [], AppFieldKeys.FILTERING_SEARCH_RADIUS_LABEL) || '',
  distanceUnitLabelKM: getConfigurationTranslationValue(
    state.dsw.translations || [], AppFieldKeys.DISTANCE_UNIT_KM),
  distanceUnitLabelMI: getConfigurationTranslationValue(
    state.dsw.translations || [], AppFieldKeys.DISTANCE_UNIT_MI),
  marketDistanceUnit: getConfigurationMarketProperty(
    state.dsw.configuration || {},
    state.dsw.settings.market,
    TemplateMarketPropertyKeys.GEN_DISTANCE_UNIT) || Globals.DEFAULT_DISTANCE_UNIT,
  marketDistanceOptions: [
    getConfigurationMarketProperty(
      state.dsw.configuration || {},
      state.dsw.settings.market,
      TemplateMarketPropertyKeys.GEN_SEARCH_RADIUS_DISTANCE_MIN) || null,
    getConfigurationMarketProperty(
      state.dsw.configuration || {},
      state.dsw.settings.market,
      TemplateMarketPropertyKeys.GEN_SEARCH_RADIUS_DISTANCE_MID) || null,
    getConfigurationMarketProperty(
      state.dsw.configuration || {},
      state.dsw.settings.market,
      TemplateMarketPropertyKeys.GEN_SEARCH_RADIUS_DISTANCE_MAX) || null,
  ],
  marketSearchRadius: getConfigurationMarketProperty(
    state.dsw.configuration || {},
    state.dsw.settings.market,
    TemplateMarketPropertyKeys.GEN_SEARCH_RADIUS) || null,
  appliedFilteringValues: state.dsw.filters[FilterType.FILTER_SEARCH_RADIUS] || [],
  searchCriteria: state.dsw.search.searchTerm,
  coordinates: state.dsw.search.coordinates
});

const mapDispatchToProps: Object = {
  modifyFilterCriteria
};

export default connect(mapStateToProps, mapDispatchToProps)(DealersFilteringDistance);
